(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:WidgetpragasvsaplicacoesCtrl
   * @description
   * # WidgetpragasvsaplicacoesCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('WidgetPragasvsAplicacoesCtrl', WidgetPragasvsAplicacoes);

  /**
   * WidgetPragasvsAplicacoes dependencies
   * @type {Array}
   */
  WidgetPragasvsAplicacoes.$inject = [
    '$rootScope',
    '$scope',
    '$http',
    'LoadingService',
    'googleChartApiPromise',
    '$filter',
    'HistoricosService',
    '$q',
    'Dashboard',
    'TiposOcorrenciasService',
    'AtividadesService',
    '$timeout'
  ];

  /**
   * WidgetPragasvsAplicacoes declaration
   */

  // eslint-disable-next-line max-params, max-lines-per-function
  function WidgetPragasvsAplicacoes($rootScope, $scope, $http, LoadingService,
    googleChartApiPromise, $filter, HistoricosService,
    $q, Dashboard, TiposOcorrenciasService, AtividadesService,
    $timeout) {
    const vm = this;
    const indexes = {
      data: 0,
      controle: 1,
      dano: 2,
      ocorrencias: 3,
      tooltipOcorrencias: 4,
      styleOcorrencias: 5,
      aplicacao: 6,
      tooltipAplicacoes: 7,
      styleAplicacoes: 8
    };

    //////////////////////////////////////////
    // Controller data
    vm.loading = false;
    vm.empty = false;
    vm.error = false;
    vm.chartStyle = {
      width: '100%',
      height: 'auto'
    };
    vm.charts = [];
    vm.applications = [];

    //////////////////////////////////////////
    // Bindable methods
    vm.validChart = ValidChart;
    vm.calcChartWidth = CalcChartWidth;

    //////////////////////////////////////////
    // Function declarations

    function ValidChart() {
      return ($scope.widget.dataModelOptions.gleba || $rootScope.globalGleba) &&
             ($scope.widget.dataModelOptions.safra || $rootScope.globalSafra) &&
             $scope.widget.dataModelOptions.tipo && $scope.widget.dataModelOptions.grupo_insumo;
    }

    // eslint-disable-next-line max-lines-per-function
    function ChartObject() {
      return {
        type: 'ComboChart',
        data: {
          cols: [],
          rows: []
        },
        options: {
          title: '',
          subtitle: '',
          chartArea: { width: '70%' },
          colors: ['#01365c'],
          pointSize: 10,
          annotations: {
            alwaysOutside: true
          },
          seriesType: 'line',
          series: {
            0: {
              color: '#aa3',
              pointsVisible: false,
              lineDashStyle: [4, 4],
              tooltip: false
            },
            1: {
              color: '#f00',
              pointsVisible: false,
              lineDashStyle: [4, 4],
              tooltip: false
            },
            2: {
              color: '#01365c',
              pointShape: 'circle'
            },
            3: {
              type: 'bars',
              color: '#4294c2'
            }
          },
          theme: 'material',
          vAxis: {
            title: ''
          },
          hAxis: {
            title: ''
          },
          height: 300,
          tooltip: {
            isHtml: true
          }
        }
      };
    }

    /*
    Este método ajusta a linha do gráfico nos dias em que só houve pulverização
    */
    function AdjustLineChart(data) {
      data.forEach((item, index) => {
        const value = item[indexes.ocorrencias];
        if (!value) {
          const priorIndex = data.findIndex((internalItem, internalIndex) => (
            internalIndex > 0 && internalIndex < index && !!internalItem[indexes.ocorrencias]
          ));
          const nextIndex = data.findIndex((internalItem, internalIndex) => (
            internalIndex > 0 && internalIndex > index && !!internalItem[indexes.ocorrencias]
          ));
          if (nextIndex >= 0 && priorIndex >= 0) {
            const priorValue = data[priorIndex][indexes.ocorrencias];
            const nextValue = data[nextIndex][indexes.ocorrencias];
            const quantity = nextIndex - priorIndex;
            const newValue = nextValue - priorValue;
            const step = (newValue / quantity);
            item[indexes.ocorrencias] = priorValue + (step * (index - priorIndex));
          }
        }
      });
    }

    // eslint-disable-next-line complexity
    function GetTextClassification(value) {
      let text = 'Baixa';

      if (value >= 1 && value < 1.75) {
        text = 'Média-Baixa';
      } else if (value >= 1.75 && value < 2.25) {
        text = 'Média';
      } else if (value >= 2.25 && value < 2.75) {
        text = 'Média-Alta';
      } else if (value >= 2.75) {
        text = 'Alta';
      }

      return text;
    }

    // eslint-disable-next-line max-lines-per-function, complexity
    function PrepareCharts(data) {
      const output = [];

      const hasData = (data.indicadores || []).some((indicador) => !!indicador.indicador.dados.length);
      if (hasData) {
        const indicadores = data.indicadores.filter((indicador) => indicador.indicador.dados.length);
        output.length = indicadores.length;
        vm.empty = false;

        for (let i = 0, len = output.length; i < len; i++) {
          const indicador = indicadores[i].indicador;
          const add = ChartObject();
          output[i] = add;
          let biggest = 0;
          const allData = [
            [
              'Data',
              'Controle',
              'Dano',
              'Ocorrências',
              { role: 'tooltip', p: { html: true } },
              { role: 'style' },
              'Aplicação',
              { role: 'tooltip', p: { html: true } },
              { role: 'style' }
            ]
          ];

          add.options.title = `${$filter('capitalize')(indicador.descricao)
          } (${ $filter('capitalize')(indicador.nome_cientifico) }): ${
            $filter('capitalize')(indicador.titulo)}`;

          const group = indicador.dados.concat(data.aplicacoes).sort((a, b) => moment(a.data) - moment(b.data));

          biggest = Math.max(biggest, +indicador.niveis[0] || 0, +indicador.niveis[1] || 0);

          // eslint-disable-next-line max-lines-per-function, complexity
          group.forEach((dado) => {
            const date = moment(dado.data).format('DD/MM/YY');
            let last = allData.pop();
            let nGroup;
            if (last[indexes.data] === date) {
              nGroup = last;
            } else {
              nGroup = [
                moment(dado.data).format('DD/MM/YY'), // data
                +indicador.niveis[0], // controle
                +indicador.niveis[1], // dano
                null, // ocorrencias
                null, // tooltipOcorrencias
                null, // styleOcorrencias
                0, // aplicacao
                null, // tooltipAplicacoes,
                null // styleAplicacoes
              ];
              allData.push(last);
              last = null;
            }

            const isPulverizacao = !!dado.hint;
            if (!isPulverizacao) {
              nGroup[indexes.ocorrencias] = +dado.media;
            } else {
              if (nGroup[indexes.tooltipAplicacoes]) {
                nGroup[indexes.tooltipAplicacoes] = `${
                  nGroup[indexes.tooltipAplicacoes]
                    .substr(
                      0,
                      nGroup[indexes.tooltipAplicacoes]
                        .indexOf('</ul>')
                    )
                }
                    <li>${ dado.hint }</li>
                </ul>`;
              } else {
                nGroup[indexes.tooltipAplicacoes] = `<ul><li>${ dado.hint }</li></ul>`;
              }
              nGroup[indexes.styleAplicacoes] = 'opacity: 0.5';
            }

            biggest = Math.max(biggest, +dado.media || 0);

            if (!last && nGroup[indexes.ocorrencias] !== null) {
              if (indicador.tipo_indicador === 'P') {
                nGroup[indexes.tooltipOcorrencias] = `Ocorrências: ${
                  $filter('number')(nGroup[indexes.ocorrencias], 1).toString()
                }%`;
                add.options.vAxis.format = 'percent';
                nGroup[indexes.controle] /= 100;
                nGroup[indexes.dano] /= 100;
                nGroup[indexes.ocorrencias] /= 100;
              } else if (indicador.tipo_indicador === 'V') {
                nGroup[indexes.tooltipOcorrencias] = `${indicador.titulo}: ${
                  $filter('number')(nGroup[indexes.ocorrencias], 1).toString()
                }`;
              } else {
                const text = GetTextClassification(nGroup[indexes.ocorrencias]);
                nGroup[indexes.tooltipOcorrencias] = `Ocorrências: ${ text}`;
                add.options.vAxis.textPosition = 'none';
              }
            }
            if (nGroup[indexes.ocorrencias] === null) {
              nGroup[indexes.tooltipOcorrencias] = '<div></div>';
              if (indicador.tipo_indicador === 'P') {
                nGroup[indexes.controle] /= 100;
                nGroup[indexes.dano] /= 100;
              }
              nGroup[indexes.styleOcorrencias] = 'point {size: 0}';
            }

            allData.push(nGroup);
          });

          allData.forEach(function(item, index) {
            const first = !index;
            const isPulverizacao = !!item[indexes.tooltipAplicacoes];
            if (first || !isPulverizacao) {
              return;
            }
            item[indexes.aplicacao] = biggest + 2;
            if (indicador.tipo_indicador === 'P') {
              item[indexes.aplicacao] /= 100;
            }
          });

          AdjustLineChart(allData);

          const dataTable = google.visualization.arrayToDataTable(allData);
          add.data = dataTable;
        }
      } else {
        vm.empty = true;
      }

      return output;
    }

    // eslint-disable-next-line complexity
    function RerenderChart() {
      if (ValidChart()) {
        vm.loading = true;
        vm.empty = false;
        vm.error = false;

        vm.charts.length = 0;

        Dashboard.pragasVsAplicacoes({
          gleba: ($scope.widget.dataModelOptions.gleba || $rootScope.globalGleba || {}).id,
          safra: ($scope.widget.dataModelOptions.safra || $rootScope.globalSafra || {}).id,
          grupo_insumo: ($scope.widget.dataModelOptions.grupo_insumo || {}).id,
          tipo: ($scope.widget.dataModelOptions.tipo || {}).id,
          atividade: ($scope.widget.dataModelOptions.cultura || {}).id
        }).then(function(response) {
          return googleChartApiPromise.then(function() {
            vm.charts = PrepareCharts(response.data);
          });
        })
          .catch(function(response) {
            console.error('Falha ao obter dados', response);
            vm.error = true;
          })
          .finally(function() {
          // Atraso devido ao tempo para renderização do gráfico
            $timeout(() => {
              vm.loading = false;
            }, 1000);
          });
      }
    }

    function CalcChartWidth() {
      return Dashboard.calcChartWidth($scope.widget.size.width);
    }

    //////////////////////////////////////////
    // Controller logic
    if (!$scope.widget.dataModelOptions.modal) {
      LoadingService.showLoading();

      // eslint-disable-next-line max-lines-per-function
      $rootScope.initialize.then(function() {
        $scope.widget.data = {};

        const promises = [
          AtividadesService.listComEmpreendimento().then(function(result) {
            $scope.widget.data.culturas = result.data;
          })
        ];

        $rootScope.propriedades.forEach(function(propriedade) {
          promises.push(
            HistoricosService.listGruposInsumos({
              propriedade: propriedade.id
            }).then(function(response) {
              propriedade.grupos_insumo = response.data.map(function(insumo) {
                return {
                  id: insumo.id[1],
                  descricao: insumo.descricao
                };
              });

              if (propriedade.id === $rootScope.currentPropriedade.id) {
                $rootScope.currentPropriedade = propriedade;
              }
            })
          );
        });

        $scope.widget.data.propriedades = [];

        $q.all(promises).then(function() {
          $scope.widget.data.propriedades = $rootScope.propriedades.map(function(propriedade) {
            const obj = {
              id: propriedade.id,
              glebas: propriedade.glebas.map(function(gleba) {
                return {
                  id: gleba.id,
                  descricao: gleba.descricao
                };
              }),
              descricao: propriedade.descricao,
              grupos_insumo: propriedade.grupos_insumo
            };

            return obj;
          });

          LoadingService.hideLoading();
        });

        $scope.widget.data.safras = $rootScope.safras.map(function(safra) {
          return {
            id: safra.id,
            descricao: safra.descricao
          };
        });

        TiposOcorrenciasService.list({ noPaginate: true }).then(function(response) {
          $scope.widget.data.tipos = response.data.map(function(tipo) {
            return {
              id: tipo.id,
              descricao: `${tipo.descricao } (${ tipo.nome_cientifico })`
            };
          });
        });

        $scope.$watch('widget.dataModelOptions', RerenderChart, true);
        $scope.$watch('$root.globalGleba', RerenderChart);
        $scope.$watch('$root.globalSafra', RerenderChart);
      }, $rootScope.errorRootInitialize);
    } else {
      RerenderChart();
    }

    $scope.$watch('widget.size.width', function() {
      vm.charts.forEach(function(chart) {
        chart.options.width = `${vm.calcChartWidth() }px`;
      });
    });
  }
}());
